var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SAIStickyPageTabs',{staticClass:"print-hide",attrs:{"disable":_vm.disableNavigation,"value":_vm.currentTab,"tabs":_vm.tabs,"single-column-desktop-width":""},on:{"click:tab":_vm.tabSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }